import React, { useState, useEffect } from 'react';
import { getCookie, setCookie } from '../utils/cookies';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if the user has already made a choice
    const consent = getCookie('user-consent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setCookie('user-consent', 'accepted', 365); // Save for 1 year
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div style={styles.banner}>
      <div style={styles.content}>
        <p>
          We use cookies to personalize ads and analyze our traffic. By clicking "Accept," 
          you consent to our use of cookies. 
          <a href="#privacy" style={styles.link}> Learn more</a>
        </p>
        <button onClick={handleAccept} style={styles.button}>
          Accept All
        </button>
      </div>
    </div>
  );
};

const styles = {
  banner: {
    position: 'fixed',
    bottom: '20px',
    left: '20px',
    right: '20px',
    backgroundColor: '#1e293b',
    color: '#fff',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    border: '1px solid #334155'
  },
  content: {
    maxWidth: '800px',
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    flexWrap: 'wrap',
    justifyContent: 'center'
  },
  button: {
    backgroundColor: '#2563eb',
    color: '#fff',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: '600'
  },
  link: {
    color: '#93c5fd',
    textDecoration: 'underline',
    fontSize: '13px',
    marginLeft: '5px'
  }
};

export default CookieBanner;